import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import logo from "../../assets/logos/logo.png";
import "../../styles/Footer.css";

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="site-footer" id="site-footer">
      <div className="container">
        <div className="row g-5">

          {/* Col 1 — Logo + description + social */}
          <div className="col-lg-3 col-md-6">
            <img src={logo} alt="Al Madina Steel" className="footer-logo" />
            <p className="footer-description">{t("footer-description")}</p>
            <div className="footer-social">
              <a
                href="https://www.facebook.com/share/181Edj48u2/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <i className="bi bi-facebook" />
              </a>
              <a
                href="https://www.instagram.com/almadinasteel/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <i className="bi bi-instagram" />
              </a>
              <a
                href="https://www.youtube.com/@almadinasteel6302"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <i className="bi bi-youtube" />
              </a>
              <a
                href="https://www.linkedin.com/company/almadinasteel/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <i className="bi bi-linkedin" />
              </a>
            </div>
          </div>

          {/* Col 2 — Quick Links */}
          <div className="col-lg-2 col-md-6">
            <span className="footer-col-title">{t("footer-quick-links")}</span>
            <ul className="footer-links">
              <li><Link to="/">{t("Home")}</Link></li>
              <li><Link to="/steel-products/rebar">{t("Rebar")}</Link></li>
              <li><Link to="/steel-products/billet">{t("Billet")}</Link></li>
              <li><Link to="/projects/mega-projects">{t("Mega Projects")}</Link></li>
              <li><Link to="/quality-control">{t("Quality Control")}</Link></li>
              <li><Link to="/certifications">{t("Certifications")}</Link></li>
              <li><Link to="/who-we-are">{t("Who We Are")}</Link></li>
            </ul>
          </div>

          {/* Col 3 — Information links */}
          <div className="col-lg-2 col-md-6">
            <span className="footer-col-title">{t("footer-info-title")}</span>
            <ul className="footer-links">
              <li><Link to="/contact-us">{t("Contact Us")}</Link></li>
              <li><Link to="/catalogue">{t("Catalogue")}</Link></li>
              <li><Link to="/accreditation">{t("Accreditation & Approvals")}</Link></li>
              <li><Link to="/about">{t("Who We Are")}</Link></li>
            </ul>
          </div>

          {/* Col 4 — Contact */}
          <div className="col-lg-4 col-md-6">
            <span className="footer-col-title">{t("Contact Us")}</span>

            <div className="footer-contact-item">
              <span className="footer-contact-label">{t("footer-call-us")}</span>
              <a href="tel:01122222385" className="footer-contact-value">
                01122222385
              </a>
              <a href="tel:+20225270107" className="footer-contact-value" style={{ fontSize: "13px", opacity: 0.75 }}>
                +20 225 270 107 &nbsp;|&nbsp; +20 225 270 108
              </a>
            </div>

            <div className="footer-contact-item">
              <span className="footer-contact-label">{t("footer-mail-us")}</span>
              <a href="mailto:info@almadina-steel.com" className="footer-contact-value">
                info@almadina-steel.com
              </a>
            </div>

            <div className="footer-contact-item">
              <span className="footer-contact-label">{t("HeadQuarter")}</span>
              <span className="footer-contact-value" style={{ fontSize: "13px", fontWeight: 400, color: "rgba(255,255,255,0.65)" }}>
                {t("H.Q:48 Street 105, Maadi Al Khabiri Al Gharbeyah, Al Maadi Cairo")}
              </span>
            </div>
          </div>

        </div>
      </div>

      {/* Copyright bar */}
      <div className="footer-divider">
        <div className="container">
          <p className="footer-copyright">{t("Copyrights")}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
